"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLinkedRecordValueEmpty = exports.isSingleEntryAllowedInParent = exports.getLinkedFields = exports.getDefaultLinkedFieldSlug = exports.hasLinkedFields = void 0;
const hasLinkedFields = (application) => application.structure.some(isLinkedRecordField);
exports.hasLinkedFields = hasLinkedFields;
const isLinkedRecordField = (field) => field.field_type === "linkedrecordfield";
/**
 * Returns the default slug from the linked field record.
 *
 * Used to get the default value of the linked_field parameter that refers to the
 * linked record. If there is only one linked record field in the list, then we
 * should set its slug by default, otherwise, it will return an empty value so that
 * the user can define the linked record field himself.
 *
 * @param field   a field that refers to a linked record field
 * @param fields  a list of the fields that contains the linked record field
 */
const getDefaultLinkedFieldSlug = (field, fields) => {
    var _a, _b;
    const isLinkedFieldSpecified = !!((_a = field === null || field === void 0 ? void 0 : field.params) === null || _a === void 0 ? void 0 : _a.linked_field);
    if (isLinkedFieldSpecified) {
        return (_b = field.params.linked_field) !== null && _b !== void 0 ? _b : "";
    }
    const linkedFields = (0, exports.getLinkedFields)(fields);
    const isOnlyOneLinkedRecordField = linkedFields.length === 1;
    return isOnlyOneLinkedRecordField ? linkedFields[0].slug : "";
};
exports.getDefaultLinkedFieldSlug = getDefaultLinkedFieldSlug;
const getLinkedFields = (structure) => structure.filter(isLinkedRecordField);
exports.getLinkedFields = getLinkedFields;
const isSingleEntryAllowedInParent = (field, symmetricField) => {
    const isMirroredField = !!field.params.autocreated_symmetric_field;
    const isLinkedToItself = field.params.symmetric_field === field.slug;
    const parentIsSingle = !!symmetricField && symmetricField.params.entries_allowed === "single";
    return parentIsSingle && (isMirroredField || isLinkedToItself);
};
exports.isSingleEntryAllowedInParent = isSingleEntryAllowedInParent;
const isLinkedRecordValueEmpty = (fieldValue) => {
    if (!fieldValue)
        return true;
    return !!fieldValue && Array.isArray(fieldValue) && fieldValue.length === 0;
};
exports.isLinkedRecordValueEmpty = isLinkedRecordValueEmpty;
